import * as React from 'react';

import MainMenu from '../../containers/MainMenu';
import MessageDetailContainer from '../../containers/MessageDetail';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * お知らせ一覧画面
 * @param props
 */
const MessageDetail: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('MessageDetail_0006')} />
			<MessageDetailContainer {...props} />
		</>
	);
};

export default MessageDetail;



// WEBPACK FOOTER //
// ./src/pages/personal/MessageDetail.tsx